import * as actionTypes from '../actions/actionTypes'
export const authenticateReducer = (state = {}, action) => {
    switch (action.type) {
      case actionTypes.AUTHENTICATE_USER:
        return action.authInfo;
      default:
        return state;
    }
  };